export const API_URL = "";

export const API_ENDPOINTS = {
  EMPLOYEES: "/api/employees",
  AUTH: "/api/auth",
  BRANCHES: "/api/branches",
  COMPANIES: "/api/companies",
  USERS: "/api/users",
  ATTENDANCE: "/api/attendance",
  LEAVE: "/api/leave",
  MOBILE: "/api/mobile",
  EMERGENCY_LOGOUTS: "/api/admin/emergency-logouts",
  DEVICE_CHANGE_REQUESTS: "/api/admin/device-change-requests",
  SUSPICIOUS_LOGINS: "/api/admin/suspicious-logins",
  OVERTIME: "/api/overtime",
  ADMIN_LOGS: "/api/admin/logs",
} as const;